import { connect } from 'react-redux';

import Footer from './footer.jsx';

import {
  getCustomFooterHtml
} from 'zoomforth_codesbane_viewer/reducers/index.js';


const mapStateToProps = (state) => {
  return {
    footerHtml: getCustomFooterHtml(state)
  };
};


const mapDispatchToProps = (dispatch) => (
  {
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Footer);
